import { useState } from "react";
import firebase from "firebase/app";
import { getSubscriptions, getUsers } from "./api";
import { UserList } from "./UserList";
import styled from "@emotion/styled";
import { uniqBy } from "lodash";

interface IProps {
  user: firebase.User;
}

const Input = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: 4
})

const InputsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: 20,
})

const SearchUsers = ({ user }: IProps) => {
  const [groupInput, setGroupsInput] = useState("");
  const [roleInput, setRolesInput] = useState("");
  const [tierInput, setTierInput] = useState("");
  const [emailInput, setEmailInput] = useState("");
  const [userList, setUserList] = useState<
    { email: string; roles?: string[]; groups?: string[] }[] | { email: string, tier: string }[]
  >([]);

  const [isLoading, setLoading] = useState(false);

  const handleSubmit = async (event: React.MouseEvent) => {
    event.preventDefault();
    const role = roleInput;
    const group = groupInput;
    const email = emailInput;
    const tier = tierInput;

    setLoading(true);

    const idToken = await user.getIdToken();

    if (tier) {
      const response = await getSubscriptions(idToken)({ tier });

      if (response.ok) {
        const result = await response.json();
        const { entries: subscriptions } = result;
        const activeSubsriptions = subscriptions.filter(({ status }: { status: string }) => ['active', 'past_due', 'trialing'].includes(status))

        const users = activeSubsriptions.map(({ customerEmail, tier }: { customerEmail: string, tier: string }) => ({ email: customerEmail, tier }));
        const uniqueUsers = uniqBy<{ email: string, tier: string }>(users, 'email');
        console.log({ users });

        setUserList(uniqueUsers);
        setLoading(false);
      } else {
        setLoading(false);
        alert(
          `Oops something went wrong endpoint returned status ${response.status}`
        );
      }
    } else {
      const response = await getUsers(idToken)({ email, role, group });

      if (response.ok) {
        const result = await response.json();
        const { users } = result;
        setUserList(users);
        setLoading(false);
      } else {
        setLoading(false);
        alert(
          `Oops something went wrong endpoint returned status ${response.status}`
        );
      }
    }
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRolesInput("");
    setGroupsInput("");
    setEmailInput(event.target.value);
  };

  return (
    <div>
      <h4>Search users</h4>
      <InputsContainer>
        <Input>
          Email
          <input
            value={emailInput}
            disabled={!!tierInput}
            onChange={handleEmailChange}
            style={{ width: '100%' }}
            placeholder="i.e. some@email.com"
            id="email"
          />
          <br />
        </Input>
        <Input>
          Role
          <select
            name="role"
            id="role-input"
            style={{ width: '100%' }}
            disabled={!!emailInput || !!tierInput}
            placeholder="Select"
            value={roleInput}
            onChange={(event) => {
              setRolesInput(event.target.value);
            }}
          >
            <option value=""></option>
            <option value="Therapist">Therapist</option>
            <option value="Admin">Admin</option>
            <option value="Wavepaths Guide">Guide</option>
            <option value="Composer">Composer</option>
          </select>
          <br />
        </Input>
        <Input>
          Group
          <input
            value={groupInput}
            onChange={(event) => setGroupsInput(event.target.value)}
            style={{ width: '100%' }}
            id="group"
            placeholder="i.e. Beta"
            disabled={!!emailInput || !!tierInput}
          />
        </Input>
        <Input>
          Tier
          <select
            name="role"
            id="role-input"
            style={{ width: '100%' }}
            disabled={!!emailInput || !!roleInput || !!groupInput}
            placeholder="Select"
            value={tierInput}
            onChange={(event) => {
              setTierInput(event.target.value);
            }}
          >
            <option value=""></option>
            <option value="beta">Beta</option>
            <option value="starter">Starter</option>
            <option value="advanced">Advanced</option>
            <option value="pro-1">Pro 1</option>
            <option value="pro-2">Pro 2</option>
            <option value="pro-3">Pro 3</option>
          </select>
          <br />
        </Input>
        <button style={{
          padding: '8px 22px',
          height: 'fit-content',
          alignSelf: 'center',
        }} onClick={handleSubmit}>Submit</button>
      </InputsContainer>
      {isLoading ? <div style={{ width: '100%', padding: 20, textAlign: 'center' }}>Loading...</div>
        : !userList.length
          ? <div style={{ width: '100%', padding: 20, textAlign: 'center' }}>No users</div>
          : <UserList fbUser={user} users={userList} />}
    </div>
  );
};

export default SearchUsers;
